import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DepartmentService } from '../../services/jrni/department.service';

@Component({
  selector: 'app-session',
  templateUrl: './session.component.html',
  styleUrls: ['./session.component.scss']
})
export class SessionComponent implements OnInit {

  constructor(
    private departmentService: DepartmentService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  restart(): void {
    this.departmentService.get().then(
      async (selectedDepartment) => {
        console.log(selectedDepartment)
        if (selectedDepartment) {
          this.router.navigate([''], { queryParams: { location: selectedDepartment.id } });
        } else {
          this.router.navigate(['/departments']);
        }
      });
  }
}
